import type { ConnectionState } from "../../types/chat";

interface ConnectionBannerProps {
  state: ConnectionState;
}

export function ConnectionBanner({ state }: ConnectionBannerProps) {
  if (state === "connected" || state === "connecting") return null;

  return (
    <div
      role="alert"
      className="sticky top-0 z-10 flex items-center justify-center gap-2 bg-warning-light px-4 py-2 text-body-sm font-medium text-amber-800"
    >
      {state === "reconnecting" ? (
        <>
          <svg
            aria-hidden="true"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className="shrink-0 motion-safe:animate-spin"
          >
            <path
              d="M8 0L9.5 6.5L16 8L9.5 9.5L8 16L6.5 9.5L0 8L6.5 6.5L8 0Z"
              fill="currentColor"
            />
          </svg>
          <span>Connection lost. Reconnecting...</span>
        </>
      ) : (
        <>
          <span>Unable to connect.</span>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="underline hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-800"
          >
            Reload page
          </button>
        </>
      )}
    </div>
  );
}
